/*
 * @Author: wzh
 * @Date: 2023-07-31 11:21:35
 * @LastEditTime: 2023-07-31 11:59:13
 * @Description: 错误页面导出
 */

import NotAccess from "./notAccess.vue";
import NotFound from "./404.vue";

export { NotAccess, NotFound };
